// extracted by css-extract-rspack-plugin
export default {"link":"f3xjd","subCategories":"ppRXO"};